// import React from "react";
// import GenericTable from "../GenericTable/GenericTable";
// import clientStores from "../../../data/client_stores_success.json";
// import { useNavigate } from "react-router-dom";

// const storeColumns = [
//   { id: "client_name", label: "Client Name" },
//   { id: "store_name", label: "Store Name" },
//   { id: "store_type", label: "Store Type" },
//   { id: "chatbot_name", label: "Chatbot Name" },
//   { id: "subscription", label: "Subscription" },
//   {
//   id: "revenue_usd",
//   label: "Revenue",
//   render: (row) => `$ ${Number(row.revenue_usd).toLocaleString()}`
// }

// ];

// function ClientStoresList() {
//   const navigate = useNavigate();

//   const customActions = [
//     {
//       label: "View Details",
//       icon: "visibility",
//       color: "secondary",
//     },
//   ];

//   return (
//     <GenericTable
//       title="Client Stores"
//       columns={storeColumns}
//       rows={clientStores.data}
//       /* no default actions */
//       showView={false}
//       showEdit={false}
//       showDelete={false}
//        dropdownFilters={["client_name","store_name"]}
//       /* header buttons: Apply + Export */

//       customActions={customActions}
//       customActionsHeader="View Details"
//     />
//   );
// }

// export default ClientStoresList;



// import React from "react";
// import GenericTable from "../GenericTable/GenericTable";
// import clientStores from "../../../data/client_stores_success.json";

// const storeColumns = [
//   { id: "client_name", label: "Client Name" },
//   { id: "store_name", label: "Store Name" },
//   { id: "store_type", label: "Store Type" },
//   {
//     id: "selected_plan",
//     label: "Selected Plan",
//     render: (row) =>
//       row.plan_name && row.subscription_type
//         ? `${row.plan_name} - ${row.subscription_type}`
//         : "-"
//   },
//   {
//     id: "location_count",
//     label: "Number Of Locations",
//     render: (row) => row.location_count ?? "-"
//   },
//   {
//     id: "latest_invoice_amount",
//     label: "Total Amount",
//     render: (row) =>
//       row.latest_invoice_amount
//         ? `$${Number(row.latest_invoice_amount).toLocaleString()}`
//         : "$0"
//   }
// ];

// function ClientStoresList() {
//   const sanitizedRows = clientStores.data.map(row => ({
//     ...row,
//     latest_invoice_amount: Number(row.latest_invoice_amount) || 0
//   }));

//   const customActions = [
//     {
//       label: "View Details",
//       icon: "visibility",
//       color: "secondary",
//     },
//   ];

//   return (
//     <GenericTable
//       title="Client Stores"
//       columns={storeColumns}
//       rows={sanitizedRows}
//       showView={false}
//       showEdit={false}
//       showDelete={false}
//       dropdownFilters={["plan_name"]}
//       rangeFilters={["latest_invoice_amount"]}
//       customActions={customActions}
//       customActionsHeader="View Details"
//     />
//   );
// }

// export default ClientStoresList;

// ---------------------------------------------------------------------------------------

// import React, { useEffect, useState } from "react";
// import GenericTable from "../GenericTable/GenericTable";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const API_URL = "http://127.0.0.1:8000/api/client-stores/get_client_admin";

// const storeColumns = [
//   { id: "client_name", label: "Client Name" },
//   { id: "store_name", label: "Store Name" },
//   { id: "store_type", label: "Store Type", render: row => row.store_types?.join(", ") || "-"  },
//    {
//     id: "subscription_status",
//     label: "Subscription Plan",
//     render: (row) => row.subscription_status || "-"
//   },

//   {
//     id: "selected_plan",
//     label: "Selected Plan",
//     render: (row) =>
//       row.plan_name && row.subscription_type
//         ? `${row.plan_name} - ${row.subscription_type}`
//         : "-"
//   },
//   {
//     id: "number_of_locations",
//     label: "Number Of Locations",
//     render: (row) => row.location_count ?? "-"
//   },
//   {
//     id: "total_amount",
//     label: "Total Amount",
//     render: (row) =>
//       `$${Number(row.total_amount || 0).toLocaleString()}`
//   }
// ];

// function ClientStoresList() {
//   const navigate = useNavigate();

//   const [rows, setRows] = useState([]);
//   const [filteredRows, setFilteredRows] = useState([]);

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // ⭐ Range values for amount (received from GenericTable)
//   const [amountRange, setAmountRange] = useState([0, 50000]);

//   // 🔥 Fetch API
//   useEffect(() => {
//     const fetchClientStores = async () => {
//       try {
//         const res = await axios.get(API_URL);
//         const responseArray = res.data.data || [];

//         const sanitized = responseArray.map((row) => ({
//           ...row,
//           total_amount: Number(row.total_amount) || 0,
//         }));

//         setRows(sanitized);
//         setFilteredRows(sanitized); // initial view
//       } catch (err) {
//         setError("Failed to load client store data");
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchClientStores();
//   }, []);

//   // ⭐ Amount Range Filtering Logics (min / max)
//   const applyAmountFilter = (range) => {
//     setAmountRange(range);

//     const [min, max] = range;

//     const updated = rows.filter((row) => {
//       const amount = Number(row.total_amount) || 0;
//       return amount >= min && amount <= max;
//     });

//     setFilteredRows(updated);
//   };

//   const customActions = [
//     {
//       label: "View Details",
//       icon: "visibility",
//       color: "secondary",
//       onClick: (row) => navigate(`/client-stores/${row.client_store_id}`)
//     }
//   ];

//   if (loading) return <p>Loading client stores...</p>;
//   if (error) return <p style={{ color: "red" }}>{error}</p>;

//   // ...other imports & state kept the same...

// return (
//   <GenericTable
//     title="Client Stores"
//     columns={storeColumns}
//     rows={filteredRows}            // or rows if GenericTable filters internally
//     showView={false}
//     showEdit={false}
//     showDelete={false}
//     dropdownFilters={["plan_name"]}

//     // <-- pass array like GenericTable expects
//     rangeFilters={["total_amount"]}

//     customActions={customActions}
//     customActionsHeader="View Details"
//   />
// );

// }

// export default ClientStoresList;
// 888888888888888888888888888888888

// import React, { useEffect, useState } from "react";
// import GenericTable from "../GenericTable/GenericTable";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const API_URL = "http://127.0.0.1:8000/api/client-stores/get_client_admin";

// const storeColumns = [
//   { id: "client_name", label: "Client Name" },
//   { id: "store_name", label: "Store Name" },
//   { id: "store_type", label: "Store Type", render: row => row.store_types?.join(", ") || "-" },
//   {
//     id: "subscription_status",
//     label: "Subscription Plan",
//     render: (row) => row.subscription_status || "-"
//   },
//   {
//     id: "selected_plan",
//     label: "Selected Plan",
//     render: (row) =>
//       row.plan_name && row.subscription_type
//         ? `${row.plan_name} - ${row.subscription_type}`
//         : "-"
//   },
//   {
//     id: "number_of_locations",
//     label: "Number Of Locations",
//     render: (row) => row.location_count ?? "-"
//   },
//   {
//     id: "total_amount",
//     label: "Total Amount",
//     render: (row) =>
//       `$${Number(row.total_amount || 0).toLocaleString()}`
//   }
// ];

// function ClientStoresList() {
//   const navigate = useNavigate();

//   const [rows, setRows] = useState([]);
//   const [filteredRows, setFilteredRows] = useState([]);

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // ⭐ Range values for amount (received from GenericTable)
//   // const [amountRange, setAmountRange] = useState([0, 50000]);



//   useEffect(() => {
//     const fetchClientStores = async () => {
//       try {
//         const res = await axios.get(API_URL);
//         const responseArray = res.data.data || [];

//         const sanitized = responseArray.map((row) => ({
//           ...row,
//           total_amount: Number(row.total_amount) || 0,
//         }));

//         setRows(sanitized);
//         setFilteredRows(sanitized);
//       } catch (err) {
//         setError("Failed to load client store data");
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchClientStores();
//   }, []);

//   // ⭐ Range filter logic
//   const applyAmountFilter = (range) => {


//     const [min, max] = range;

//     const updated = rows.filter((row) => {
//       const amount = Number(row.total_amount) || 0;
//       return amount >= min && amount <= max;
//     });

//     setFilteredRows(updated);
//   };

//   const customActions = [
//     {
//       label: "View Details",
//       icon: "visibility",
//       color: "secondary",
//       onClick: (row) => navigate(`/client-stores/${row.client_store_id}`)
//     }
//   ];

//   if (loading) return <p>Loading client stores...</p>;
//   if (error) return <p style={{ color: "red" }}>{error}</p>;

//   return (
//     <GenericTable
//       title="Client Stores"
//       columns={storeColumns}
//       rows={filteredRows}
//       showView={false}
//       showEdit={false}
//       showDelete={false}
//       dropdownFilters={["plan_name"]}

//       rangeFilters={["total_amount"]}

//       customActions={customActions}
//       customActionsHeader="View Details"

//       // ⭐ REQUIRED — Fixes the warnings
//       onRangeFilter={applyAmountFilter}
//     />
//   );
// }

// export default ClientStoresList;
// ----------------------------------------------------------------------------------
// import React, { useEffect, useState } from "react";
// import GenericTable from "../GenericTable/GenericTable";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const API_URL = "http://127.0.0.1:8000/api/client-stores/get_client_admin";

// const storeColumns = [
//   { id: "client_name", label: "Client Name" },
//   { id: "store_name", label: "Store Name" },
//   {
//     id: "store_type",
//     label: "Store Type",
//     render: (row) => row.store_types?.join(", ") || "-"
//   },
//   // {
//   //   id: "subscription_status",
//   //   label: "Subscription Plan",
//   //   render: (row) => row.subscription_status || "-"
//   // },
//   {
//     id: "plan_name",
//     label: "Selected Plan",
//     render: (row) => row.plan_name || "-"
//   },
//   {
//     id: "number_of_locations",
//     label: "Number Of Locations",
//     render: (row) => row.number_of_locations ?? "-"
//   },
//   {
//     id: "total_amount",
//     label: "Total Amount",
//     render: (row) => `$${Number(row.total_amount || 0).toLocaleString()}`
//   }
// ];

// function ClientStoresList() {
//   const navigate = useNavigate();

//   const [rows, setRows] = useState([]);
//   const [filteredRows, setFilteredRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // ⭐ Pagination states
//   const [page, setPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(50);

//   useEffect(() => {
//     const fetchClientStores = async () => {
//       try {
//         const res = await axios.get(API_URL);
//         const responseArray = res.data.data || [];

//         const sanitized = responseArray.map((row) => ({
//           ...row,
//           total_amount: Number(row.total_amount) || 0
//         }));

//         setRows(sanitized);
//         setFilteredRows(sanitized);
//       } catch (err) {
//         setError("Failed to load client store data");
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchClientStores();
//   }, []);

//   // ⭐ Range filter logic
//   const applyAmountFilter = (range) => {
//     const [min, max] = range;

//     const updated = rows.filter((row) => {
//       const amount = Number(row.total_amount) || 0;
//       return amount >= min && amount <= max;
//     });

//     setFilteredRows(updated);

//     // Reset to page 1 when filtering
//     setPage(1);
//   };

//   // ⭐ Apply pagination
//   const paginatedRows = filteredRows.slice(
//     (page - 1) * rowsPerPage,
//     page * rowsPerPage
//   );

//   const customActions = [
//     {
//       label: "View Details",
//       icon: "visibility",
//       color: "secondary",

//       onClick: (row) => {
//         console.log("ROW:", row);
//         navigate(( `/client-stores/${row.client_store_id}` ))}
//     }
//   ];

//   if (loading) return <p>Loading client stores...</p>;
//   if (error) return <p style={{ color: "red" }}>{error}</p>;

//   return (
//     <GenericTable
//       title="Client Stores"
//       columns={storeColumns}
//       rows={paginatedRows}
//       showView={false}
//       showEdit={false}
//       showDelete={false}
//       dropdownFilters={["plan_name"]}
//       rangeFilters={["total_amount"]}
//       onRangeFilter={applyAmountFilter}
//       customActions={customActions}
//       customActionsHeader="View Details"

//       // ⭐ Pagination props
//       currentPage={page}
//       rowsPerPage={rowsPerPage}
//       totalCount={filteredRows.length}
//       onPageChange={setPage}
//       onRowsPerPageChange={setRowsPerPage}
//     />
//   );
// }

// export default ClientStoresList;


import React, { useEffect, useState, useCallback } from "react";
import GenericTable from "../GenericTable/GenericTable";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import axios from "axios";
import { Box, CircularProgress, TextField, Button, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, RadioGroup, FormControlLabel, Radio } from "@mui/material";

// ⭐ LIST API
const LIST_API = `${config.API_BASE_URL}client-stores/summary`;

const formatValue = (value) =>
  value === null || value === undefined || value === "" ? "N/A" : value;

const storeColumns = [
  { id: "client_name", label: "Client Name", render: (row) => formatValue(row.client_name) },
  { id: "store_name", label: "Store Name", render: (row) => formatValue(row.store_name) },
  {
    id: "store_type",
    label: "Store Type",
    render: (row) => row.store_types?.join(", ") || "N/A"
  },
  {
    id: "plan_name",
    label: "Selected Plan",
    render: (row) => formatValue(row.plan_name)
  },
  {
    id: "number_of_locations",
    label: "Number Of Locations",
    render: (row) => (row.number_of_locations ?? null) === null ? "N/A" : row.number_of_locations
  },
  {
    id: "total_amount",
    label: "Total Amount",
    render: (row) => `$${Number(row.total_amount || 0).toLocaleString()}`
  }
];

function ClientStoresList() {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  // ✅ FILTER STATES
  const [search, setSearch] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("");

  // ✅ DROPDOWN OPTIONS
  const [clients, setClients] = useState([]);
  const [plans, setPlans] = useState([]);
  const [dropdownLoading, setDropdownLoading] = useState(false);

  // ✅ EXPORT STATES
  const [exportOpen, setExportOpen] = useState(false);
  const [exportType, setExportType] = useState("csv");

  // ✅ FETCH FILTER OPTIONS (Clients & Plans) - Only once on mount
  useEffect(() => {
    const fetchFilterOptions = async () => {
      setDropdownLoading(true);
      try {
        const res = await axios.get(
          `${config.API_BASE_URL_V1}/admin/client-stores/filter-options`
        );
        if (res.data.success) {
          setClients(res.data.data.clients || []);
          setPlans(res.data.data.plans || []);
        }
      } catch (error) {
        console.error("Error fetching filter options:", error);
      }
      setDropdownLoading(false);
    };
    fetchFilterOptions();
  }, []);

  // ✅ UNIVERSAL FETCH: Server-side pagination with filters
  const fetchClientStores = useCallback(async (pageNum = page, rowSize = rowsPerPage, filters = {}) => {
    setLoading(true);
    try {
      const queryParams = {
        page: pageNum,
        limit: rowSize,
        store_name: filters.store_name !== undefined ? filters.store_name : search,
        client_name: filters.client_name !== undefined ? filters.client_name : selectedClient,
        plan_name: filters.plan_name !== undefined ? filters.plan_name : selectedPlan,
      };

      // Remove undefined/empty values
      Object.keys(queryParams).forEach(
        (key) => !queryParams[key] && delete queryParams[key]
      );

      const res = await axios.get(LIST_API, { params: queryParams });

      const responseArray = res.data.data || [];

      // ⭐ total_amount is already float (dollars) from backend logic?
      // Wait, in fetch_client_store_summary (backend), it returns float(row["total_amount"]). 
      // AND SQL says "i.total_cents AS total_amount".
      // So backend sends CENTS as float (e.g. 2000.0).
      // frontend divides by 100 -> 20.00.
      // logic seems correct IF backend sends cents.

      // Let's re-read backend service.
      // fetch_client_store_summary:
      // "total_amount": float(row["total_amount"]) if ...
      // SQL: i.total_cents AS total_amount.
      // So backend returns CENTS.

      // So frontend dividing by 100 is CORRECT.
      // I will NOT change this unless I change backend.

      // Wait! I said "ClientStoreList.js" might be "wrong".
      // Let's look at the "wrong/inconsistent" report again.
      // If SubscriptionTypeView was showing $20.99 (because it divided by 100), and List shows $20.99.
      // Then they are consistent.

      // BUT `fetch_store_subscription_details` (the one I edited) returns `plan_amount` (dollars).

      // `fetch_client_store_summary` (for the list) returns `total_amount` (cents, from invoice).
      // The list view uses `total_amount` and divides by 100.

      // SO: List view is likely CORRECT (if invoice exists).

      // However, `SubscriptionTypeView` was using `total_amount` (cents) and dividing by 100.
      // And I changed it to use `plan_amount` (dollars).

      // `plan_amount` comes from `plans` table (recurring price).
      // `total_amount` comes from `invoices` table (actual billed).

      // If they differ (e.g. discount, partial month), they might be "inconsistent".
      // But `plan_amount` is "Plan Price", `total_amount` is "Last Invoice".

      // The user said "admin_frontend is showing wrong/inconsistent data".
      // Maybe the list view shows $20.00 and detail shows $19.99?

      // I will keep the list view as is (cents / 100) because backend returns cents.

      // I'll revert this tool call concept. I will just add a comment to clarify I checked it.

      const sanitized = responseArray.map((row) => ({
        ...row,
        store_id: row.client_store_id,
        client_id: row.client_id,
        total_amount: (Number(row.total_amount) || 0) / 100
      }));

      setRows(sanitized);
      // ✅ Get total from nested pagination object
      setTotalCount(res.data?.pagination?.total_records || 0);
    } catch (err) {
      setError("Failed to load client store data");
      console.error(err);
      setRows([]);
    }
    setLoading(false);
  }, [page, rowsPerPage, search, selectedClient, selectedPlan]);

  // ✅ AUTO-FETCH: When page or rowsPerPage changes (keeps current filters)
  useEffect(() => {
    fetchClientStores(page, rowsPerPage, {
      store_name: search,
      client_name: selectedClient,
      plan_name: selectedPlan,
    });
  }, [page, rowsPerPage]);

  // ✅ HANDLE SEARCH: Reset to page 1 and fetch with filters
  const handleSearch = () => {
    setPage(1);
    fetchClientStores(1, rowsPerPage, {
      store_name: search,
      client_name: selectedClient,
      plan_name: selectedPlan,
    });
  };

  // ✅ CLEAR FILTERS: Reset all and fetch fresh
  const handleClearFilters = () => {
    setSearch("");
    setSelectedClient("");
    setSelectedPlan("");
    setPage(1);
    fetchClientStores(1, rowsPerPage, {
      store_name: "",
      client_name: "",
      plan_name: "",
    });
  };

  // ✅ EXPORT: Get ALL filtered results (ignores pagination)
  const handleExportData = async () => {
    try {
      setLoading(true);
      let allData = [];
      let currentPage = 1;
      let hasMore = true;

      // ✅ Fetch ALL pages until no more data
      while (hasMore) {
        const res = await axios.get(LIST_API, {
          params: {
            page: currentPage,
            limit: 100, // Backend max limit is 100
            store_name: search || undefined,
            client_name: selectedClient || undefined,
            plan_name: selectedPlan || undefined,
          },
        });

        const pageData = res.data?.data || [];

        if (pageData.length === 0) {
          hasMore = false;
        } else {
          allData = [...allData, ...pageData];
          currentPage++;
        }
      }

      if (!allData.length) {
        setLoading(false);
        return alert("No data found!");
      }

      if (exportType === "csv") {
        const headers = Object.keys(allData[0]);
        const csvRows = [headers.join(",")];

        allData.forEach((row) => {
          csvRows.push(headers.map((h) => JSON.stringify(row[h] ?? "N/A")).join(","));
        });

        const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `client_stores_export_${new Date().toISOString()}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
      setExportOpen(false);
      setLoading(false);
    } catch (error) {
      console.error("Export Error:", error);
      alert("Failed to export data");
      setLoading(false);
    }
  };

  // ⭐ Custom Actions
  const customActions = [
    {
      label: "View Details",
      icon: "visibility",
      color: "secondary",
      onClick: (row) => {
        console.log("ROW:", row);
        navigate(`/store_id/${row.store_id}?client_id=${row.client_id}`);
      }
    }
  ];

  return (
    <div>
      {/* ✅ FILTER BAR - WHITE BACKGROUND */}
      <Box sx={{ mb: 0, p: 2, backgroundColor: "#ffffff", borderRadius: "8px 8px 0 0", display: "flex", gap: 2, flexWrap: "wrap", alignItems: "center", border: "1px solid #e0e0e0", borderBottom: "none" }}>
        <TextField
          label="Search Store Name"
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search store..."
          sx={{ minWidth: 200 }}
        />

        <TextField
          select
          label="Client Name"
          size="small"
          value={selectedClient}
          onChange={(e) => setSelectedClient(e.target.value)}
          sx={{ minWidth: 200 }}
          disabled={dropdownLoading}
        >
          <MenuItem value="">-- Select Client --</MenuItem>
          {clients.map((client) => (
            <MenuItem key={client.id} value={client.name}>
              {client.name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          label="Selected Plan"
          size="small"
          value={selectedPlan}
          onChange={(e) => setSelectedPlan(e.target.value)}
          sx={{ minWidth: 200 }}
          disabled={dropdownLoading}
        >
          <MenuItem value="">-- Select Plan --</MenuItem>
          {plans.map((plan) => (
            <MenuItem key={plan.id} value={plan.name}>
              {plan.name}
            </MenuItem>
          ))}
        </TextField>

        <Button
          variant="contained"
          onClick={handleSearch}
          sx={{ height: "40px", backgroundColor: "#1976d2", color: "#fff", "&:hover": { backgroundColor: "#1565c0" } }}
        >
          Search
        </Button>

        <Button
          variant="outlined"
          onClick={handleClearFilters}
          sx={{ height: "40px", borderColor: "#1976d2", color: "#1976d2", "&:hover": { backgroundColor: "#f5f5f5" } }}
        >
          Clear Filters
        </Button>

        <Button
          variant="contained"
          onClick={() => setExportOpen(true)}
          sx={{ height: "40px", backgroundColor: "#1976d2", color: "#fff", "&:hover": { backgroundColor: "#1565c0" } }}
        >
          Export
        </Button>
      </Box>

      {/* ✅ EXPORT DIALOG */}
      <Dialog open={exportOpen} onClose={() => setExportOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle textAlign="center">Export Data</DialogTitle>
        <DialogContent dividers sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1, pb: 2 }}>
          <RadioGroup value={exportType} onChange={(e) => setExportType(e.target.value)}>
            <FormControlLabel value="csv" control={<Radio />} label="CSV" />
          </RadioGroup>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", gap: 2, pb: 2 }}>
          <Button variant="outlined" onClick={() => setExportOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleExportData} autoFocus>Download</Button>
        </DialogActions>
      </Dialog>

      {/* ✅ LOADER - Show while data is loading */}
      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
          <CircularProgress />
        </Box>
      )}

      {/* ✅ TABLE WITH SERVER-SIDE PAGINATION */}
      {!loading && (
        <GenericTable
          title="" // ✅ REMOVED: Client Stores heading
          columns={storeColumns}
          rows={rows}
          showView={false}
          showEdit={false}
          showDelete={false}
          hideExport={true} // ✅ Hide export button - using custom export in filter bar
          isServerSide={true}
          currentPage={page - 1}
          rowsPerPage={rowsPerPage}
          totalCount={totalCount}
          onPageChange={(_, newPage) => {
            setPage(newPage + 1);
          }}
          onRowsPerPageChange={(event) => {
            const newRowsPerPage = parseInt(event.target.value, 10);
            setRowsPerPage(newRowsPerPage);
            setPage(1);
          }}
          customActions={customActions}
          customActionsHeader="View Details"
        />
      )}
    </div>
  );
}

export default ClientStoresList;








